import type { PlatformInfo, PlatformSelectSpec } from './types';

/**
 * Resolve a platform-keyed value spec against a snapshot. Most-specific match
 * wins (see PlatformSelectSpec doc). Returns `spec.default` if nothing matches.
 *
 * Used internally by `Platform.select`, `usePlatformValue`, and `<PlatformGate>`.
 */
export function selectByPlatform<T>(
  spec: PlatformSelectSpec<T>,
  info: PlatformInfo,
): T | undefined {
  // 1. Device-specific
  if (info.isPad && spec.ipad !== undefined) return spec.ipad;
  if (info.os === 'ios' && !info.isPad && spec.iphone !== undefined) return spec.iphone;
  if (info.isAndroidTablet && spec.androidTablet !== undefined) return spec.androidTablet;
  if (info.isAndroidPhone && spec.androidPhone !== undefined) return spec.androidPhone;

  // 2. Form factor
  if (info.isTablet && spec.tablet !== undefined) return spec.tablet;
  if (info.isPhone && spec.phone !== undefined) return spec.phone;
  if (info.isDesktop && spec.desktop !== undefined) return spec.desktop;

  // 3. OS
  if (info.os === 'ios' && spec.ios !== undefined) return spec.ios;
  if (info.os === 'android' && spec.android !== undefined) return spec.android;
  if (info.os === 'web' && spec.web !== undefined) return spec.web;

  // 4. Native vs web
  if (info.isNative && spec.native !== undefined) return spec.native;

  return spec.default;
}
